import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import SwitchInput from "../../components/SwitchInput";
import Loader from "../../components/Loader";
// Implement a react component with 
const FeatureCard = ({ featureData, isChecked, onToggle, toggling }) => {

    const handleToggle = (value) => {
        onToggle(featureData, value);
    }

    return (
        <Box sx={styles.mainView}>
            <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                <Box sx={[styles.contentBox, { opacity: toggling ? 0.5 : 1 }]}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        <Typography variant="h6" fontSize={'0.875rem'} >
                            {featureData.label}
                        </Typography>
                        <Typography variant="body2" color="#AAA">
                            {featureData.description}
                        </Typography>
                    </Box>

                    <FormGroup key={featureData._id}>
                        <FormControlLabel
                            control={
                                <Box className={styles?.["switch-input-view"]}>
                                    <SwitchInput
                                        checked={isChecked}
                                        onChange={handleToggle}
                                    />
                                </Box>
                            }
                            sx={{
                                color: '#000000',
                                margin: 0,
                                '& .MuiTypography-root': {
                                    marginLeft: '0.5rem',
                                    whiteSpace: 'nowrap'
                                }
                            }}
                        />
                    </FormGroup>
                </Box>
                {toggling && <Box sx={styles.loaderContainer}>
                    <Loader />
                </Box>}
            </Box>
        </Box>
    )
}

export default FeatureCard;

const styles = {
    mainView: {
        border: "1px solid #ddd",
        borderRadius: 2,
        backgroundColor: "#f9f9f9",
        padding: '0.25rem 0.5rem',
        m: 1,
        minHeight: '4.625rem',
    },
    contentBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 1,
        minHeight: '4.125rem', // 4.625rem - 2 * 0.25rem for padding
    },
    loaderContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}

